<div class="dialog" [class.blocked]="isBlocked">
    <!-- Blocking overlay when external status change removed note-adding permission -->
    <div *ngIf="isBlocked" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <p>{{ 'COMPLAINT|Status reklamacji został zmieniony przez innego użytkownika. Dodawanie notatek nie jest już możliwe w obecnym statusie. Zamknij okno.' | translate }}</p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="close()">
                    {{ 'INTERFACE|Zamknij' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Dodaj notatkę' | translate }}</h3>
        <button
                *ngIf="!data.blockingMode"
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div *ngIf="data.customMessage" class="custom-message">
            <p>{{ data.customMessage }}</p>
        </div>

        <div class="complaint-note-container">

            <div class="complaint-note-container__visibility">

                <h3>{{ 'COMPLAINT|Widoczność' | translate }}</h3>

                <div *ngIf="!internalNoteOnly" class="complaint-note-container__visibility-radio">
                    <icc-radio
                        name="complaint-note-visibility"
                        [value]="'private'"
                        [checked]="data.complaintNote.visibility === 'private'"
                        [(ngModel)]="data.complaintNote.visibility"
                        [disabled]="data.isReply || privateNoteOnly"
                    >
                        {{ 'COMPLAINT|Prywatna (w ramach mojej firmy)' | translate }}
                    </icc-radio>
                </div>
                <div *ngIf="!internalNoteOnly && !privateNoteOnly && getUserType() !== 'authorizedRetailer'" class="complaint-note-container__visibility-radio">
                    <icc-radio
                        name="complaint-note-visibility"
                        [value]="'manufacturerDistributor'"
                        [checked]="data.complaintNote.visibility === 'manufacturerDistributor'"
                        [(ngModel)]="data.complaintNote.visibility"
                        [disabled]="data.isReply"
                    >
                        {{ 'COMPLAINT|Dystrybutor - Producent' | translate }}
                    </icc-radio>
                </div>
                <div *ngIf="!distributorManufacturerComplaint && !privateNoteOnly" class="complaint-note-container__visibility-radio">
                    <icc-radio
                        name="complaint-note-visibility"
                        [value]="'internal'"
                        [checked]="data.complaintNote.visibility === 'internal'"
                        [(ngModel)]="data.complaintNote.visibility"
                        [disabled]="data.isReply || internalNoteOnly"
                    >
                        {{ 'COMPLAINT|Wewnętrzna (APS - Dystrybutor - Producent)' | translate }}
                    </icc-radio>
                </div>
                <div *ngIf="!internalNoteOnly && !privateNoteOnly && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint" class="complaint-note-container__visibility-radio">
                    <icc-radio
                        name="complaint-note-visibility"
                        [value]="'public'"
                        [checked]="data.complaintNote.visibility === 'public'"
                        [(ngModel)]="data.complaintNote.visibility"
                        [disabled]="data.isReply"
                    >
                        {{ 'COMPLAINT|Publiczna (Klient - APS - Dystrybutor - Producent)' | translate }}
                    </icc-radio>
                </div>

            </div>

            <div class="complaint-note-container__content">
                <div class="complaint-note-container__content-text">
                    <icc-input
                        type="textarea"
                        [name]="'complaint-note-content'"
                        [value]="data.complaintNote.content"
                        [size]="'large'"
                        [required]="false"
                        (valueChange)="data.complaintNote.content = $event"
                        [prefixIcon]="'edit'"
                        [rows]="7"
                        [cols]="80"
                        [placeholder]="'COMPLAINT|Treść notatki' | translate"
                        [label]="'COMPLAINT|Treść notatki' | translate"
                        class="textarea-resizable"
                    ></icc-input>
                </div>
            </div>

            <div class="complaint-note-container__position" *ngIf="!data.isReply">
                <div class="complaint-note-container__position-select">
                    <icc-select
                        name="serviceRating"
                        [value]="data.complaintNote.positionId"
                        (valueChange)="$event !== 'null' ? data.complaintNote.positionId = $event : data.complaintNote.positionId = null"
                        [label]="data.complaintNote.positionId !== null ? ('COMPLAINT|Kontekst usterki' | translate) : 'COMPLAINT|Wszystkie usterki' | translate"
                        size="medium"
                        [required]="false"
                        [prefixIcon]="'done'"
                        appearance="outline"
                    >
                        <option value="null">{{ 'COMPLAINT|Wszystkie usterki' | translate }}</option>
                        <option
                            *ngFor="let position of data.complaintsPositionsMap | keyvalue"
                            [value]="position.key"
                        >
                            {{ getPositionTitle(position.value).join('> ') }}
                        </option>
                    </icc-select>
                </div>
            </div>

            <div class="complaint-note-container__attachments-input">
                <label [for]="'complaintNoteAttachment' + data.complaintNote.uuid" style="cursor: pointer;">
                    <icc-icon name="add"></icc-icon>{{ ('INTERFACE|Dodaj załącznik' | translate) }}
                </label>
                <input
                    type="file"
                    [id]="'complaintNoteAttachment' + data.complaintNote.uuid"
                    (change)="onAddAttachment($event.target.files, 'complaintNoteAttachment')"
                >
                <p *ngIf="complaintNoteAttachmentError" class="invalid-message">{{ complaintNoteAttachmentError }}</p>
            </div>

            <div *ngIf="getAttachments('complaintNoteAttachment').length > 0" class="complaint-note-container__attachments-container">
                <div class="complaint-note-attachments">
                    <div class="complaint-note-attachments-body" *ngFor="let complaintNoteAttachment of getAttachments('complaintNoteAttachment'); index as i">
                        <div class="filename">
                            <span *ngIf="getAttachment(complaintNoteAttachment.attachmentType, complaintNoteAttachment.uuid)?.name" [title]="getAttachment(complaintNoteAttachment.attachmentType, complaintNoteAttachment.uuid)?.name">{{ getAttachment(complaintNoteAttachment.attachmentType, complaintNoteAttachment.uuid)?.name }}</span>
                        </div>
                        <div style="cursor: pointer;">
                            <icc-icon name="delete" (click)="removeAttachment(complaintNoteAttachment.attachmentType, complaintNoteAttachment.uuid)"></icc-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                *ngIf="!data.blockingMode"
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                iccButton
                (click)="save()"
                appearance="primary"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="!data.blockingMode && close()"
></div>
